import { render, staticRenderFns } from "./TipButton.vue?vue&type=template&id=3cd3e38a&"
import script from "./TipButton.vue?vue&type=script&lang=ts&"
export * from "./TipButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports